var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _circle3, _rect7, _rect8, _rect9, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 29H6C3.79086 29 2 27.2091 2 25V7C2 4.79086 3.79086 3 6 3H20C22.2091 3 24 4.79086 24 7V10M12 13V26C12 27.6569 13.3431 29 15 29H26C27.6569 29 29 27.6569 29 26V13C29 11.3431 27.6569 10 26 10H24M12 13C12 11.3431 13.3431 10 15 10H17.0852M12 13L10.065 13C9.7144 13 9.38937 12.8163 9.20844 12.516L8.3015 11.0104C7.92596 10.387 7.89891 9.58988 8.37893 9.04283C8.4647 8.94509 8.55387 8.84987 8.64638 8.75736C9.7716 7.63214 11.2977 7 12.889 7C14.4803 7 16.0064 7.63214 17.1317 8.75736C17.5057 9.13139 16.8252 9.54971 17.0852 10M24 10H17.0852M15 19H26C26.5523 19 27 18.5523 27 18V13C27 12.4477 26.5523 12 26 12H18.8051H15C14.4477 12 14 12.4477 14 13V18C14 18.5523 14.4477 19 15 19Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 21,
    width: 3,
    height: 2,
    rx: 0.5,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 25,
    width: 3,
    height: 2,
    rx: 0.5,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 21,
    width: 3,
    height: 2,
    rx: 0.5,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 25,
    width: 3,
    height: 2,
    rx: 0.5,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 21,
    width: 3,
    height: 2,
    rx: 0.5,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 25,
    width: 3,
    height: 2,
    rx: 0.5,
    stroke: "black",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 7,
    r: 1,
    stroke: "black",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 25,
    r: 1,
    stroke: "black",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 7,
    r: 1,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3501,
    y: 13.25,
    width: 0.5,
    height: 4.5,
    rx: 0.25,
    stroke: "black",
    strokeWidth: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3501,
    y: 13.25,
    width: 0.5,
    height: 4.5,
    rx: 0.25,
    stroke: "black",
    strokeWidth: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3501,
    y: 13.75,
    width: 0.5,
    height: 2.5,
    rx: 0.25,
    transform: "rotate(-90 22.3501 13.75)",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3989 13.099C18.3155 13.0368 18.2121 13 18.1001 13C17.824 13 17.6001 13.2239 17.6001 13.5V14.0774V15.4996V17.5C17.6001 17.7761 17.824 18 18.1001 18C18.3762 18 18.6001 17.7761 18.6001 17.5V16.8667V16.4494V16.0661V15.2317L18.8 15.5779L18.9222 15.7895L18.9612 15.8571C18.9613 15.8572 18.9613 15.8574 18.9614 15.8575C19.0995 16.0966 19.6001 16.2 19.6001 16.2C19.6001 16.2 20.1011 16.0966 20.2391 15.8575L20.2782 15.7898L20.4004 15.5782L20.6001 15.2323V16.0659V16.4496V16.8669V17.5C20.6001 17.7761 20.824 18 21.1001 18C21.3762 18 21.6001 17.7761 21.6001 17.5V15.5002V14.0772V13.5C21.6001 13.2239 21.3762 13 21.1001 13C21.0331 13 20.9692 13.0132 20.9108 13.0371C20.865 13.0558 20.8225 13.0812 20.7847 13.112C20.7789 13.1136 20.773 13.1164 20.7671 13.1203C20.7085 13.1601 20.5854 13.2578 20.4842 13.4329L20.4841 13.4333L20.4455 13.5L20.3513 13.6631L20.2099 13.9082L20.2085 13.9106L20.1776 13.964L19.6003 14.964L19.6001 14.9637L19.0229 13.964L18.755 13.5L18.7165 13.4333C18.7164 13.4332 18.7164 13.4331 18.7163 13.4329C18.5782 13.1938 18.3989 13.099 18.3989 13.099Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImt);
export default __webpack_public_path__ + "static/media/Icon_IMT.928444ffa0772e621236b0216c8de995.svg";
export { ForwardRef as ReactComponent };